import React, { useState, useEffect, useRef } from "react";
import MUIDataTable from "mui-datatables";
import {
  Grid,
  Button,
  Switch,
  TextField,
  MenuItem,
  InputLabel,
  TablePagination,
  Backdrop,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";
import PageTitle from "../../components/PageTitle";
import ViewIcon from "@material-ui/icons/Visibility";
import moment from "moment";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Autocomplete } from "@material-ui/lab";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useStyles from "../../themes/style.js";
import { jwtDecode } from "jwt-decode";
import { useHistory } from "react-router-dom";
import { useNotification } from "../../hooks/useNotification.js";


export default function Employers() {
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const history = useHistory();
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const companyType = decode?.companyType;
  const [userData, setUserData] = useState([]);

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [count, setCount] = useState(0);

  const HeaderElements = () => <>Total : {count}</>;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrerntPage(newPage + 1);

    const form = filterRef.current;

    var data = JSON.stringify({
      page: newPage + 1,
      roleName: `${form["roleName"].value}`,
      fromDate: `${form["fromDate"].value}`,
      toDate: `${form["toDate"].value}`,
      recruiterId: recruiterId,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}employee/viewAllEmployees`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setUserData(response.data.data);
        setCount(response.data.count);
      }

      setLoader(false);
    });
  };

  const handleNotificationCall = useNotification();
  const [roleName, setRoleName] = useState("");

  useEffect(() => {
    fetchUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchUserData = async () => {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}employee/viewAllEmployees`,
        data: {
          page: currerntPage,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setUserData(response.data.data);
          setCount(response.data.count);
        }
      });
      getAllUserList();
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const getAllUserList = async () => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}auth/getAllUserList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;
        const userList = responseData.filter((item) => item.fullName !== null);
        setAllUserName(userList);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  function handleStatus(id, value) {
    setLoader(true);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/changeUserState`,
      data: {
        id: id,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setLoader(false);
        const switchState = userData.map((item) => {
          if (item.id === id) {
            console.log({ ...item,isActive: value })
            return { ...item,isActive: value };
          }
          return item;
        });

        setUserData(switchState);
        handleNotificationCall("success", response.data.data);
      }
    });
  }

  const [state, setState] = useState({
    bottom: false,
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [allUserName, setAllUserName] = useState([]);
  const [recruiterId, setRecruiterId] = useState(null);

  const filterRef = useRef(null);

  const handleFromDateChange = (event) => {
    setFromDate(filterRef.current.fromDate.value);
  };

  const handleToDateChange = (event) => {
    setToDate(filterRef.current.toDate.value);
  };

  const resetForm = (e) => {
    filterRef.current.reset();
    setRoleName("");
    setRecruiterId("");
    fetchUserData();
  };

  function getFilterData() {
    setLoader(true);
    setCurrerntPage(1);
    setPage(0);
    const form = filterRef.current;

    var data = JSON.stringify({
      page: 1,
      roleName: `${form["roleName"].value}`,
      fromDate: `${form["fromDate"].value}`,
      toDate: `${form["toDate"].value}`,
      userId: recruiterId?.id,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}employee/viewAllEmployees`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setUserData(response.data.data);
          setCount(response.data.count);
        }
      })

      .catch(function (error) {
        console.log(error);
      });
  }

  return (
    <>
      <Grid container direction="row" spacing={2}>
        <Grid item xs={6}>
          <PageTitle title="Employees" />
        </Grid>

        <Grid item xs={6} className={classes.drawerClose}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={(e) => {
              // reset();
              // setEmpUserOpen(true);
              history.push("/app/add-employee");
            }}
            className={classes.addUser}
            style={{ marginRight: "15px" }}
            startIcon={<AddCircleIcon />}
          >
            Add Employee
          </Button>
        </Grid>
      </Grid>

      <form
        ref={filterRef}
        onSubmit={(e) => {
          e.preventDefault();
          getFilterData();
        }}
      >
        <Grid container spacing={2} className={classes.filterGap}>
          <div className={classes.filterFullWidth}>
            <InputLabel shrink id="roleName">
              {" "}
              User Category{" "}
            </InputLabel>

            <TextField
              name="roleName"
              variant="standard"
              defaultValue=""
              onChange={(e) => setRoleName(e.target.value)}
              value={roleName}
              InputProps={{ className: classes.h34 }}
              disableunderline="true"
              select
            >
              <MenuItem value="RECRUITER">Recruiter</MenuItem>
              <MenuItem value="CLIENTCOORDINATOR">
                {" "}
                {companyType === "COMPANY"
                  ? "Hiring Manager"
                  : "Client Coordinator"}{" "}
              </MenuItem>
              <MenuItem value="EMPLOYEE">Employee</MenuItem>
            </TextField>
          </div>
          <Autocomplete
            className={classes.filterFullWidth}
            options={allUserName}
            getOptionLabel={(option) => {
              const roleName = option.role?.roleName;
              let label = option.fullName;
              // if (roleName) {
              //   label += ` (${roleName})`;

              //   if (roleName === "SUBVENDOR") {
              //     label = label.replace(
              //       "(SUBVENDOR)",
              //       `(${option?.companyName})`,
              //     );
              //   } else if (roleName === "CLIENTCOORDINATOR") {
              //     label = label.replace(
              //       "(CLIENTCOORDINATOR)",
              //       "(Hiring Manager)",
              //     );
              //   }
              // }

              return label;
            }}
            onChange={(event, value) => {
              setRecruiterId(value);
            }}
            value={recruiterId}
            size="small"
            renderInput={(params) => (
              <TextField
                {...params}
                name="recruiterId"
                variant="standard"
                label={companyType === "COMPANY" ? "User" : "Recruiter"}
                InputLabelProps={{ shrink: true }}
                type="text"
              />
            )}
          />

          <TextField
            name="fromDate"
            label="From"
            size="small"
            type="date"
            variant="standard"
            format={"DD/MM/YYYY"}
            InputLabelProps={{ shrink: true }}
            className={classes.filterWidth}
            defaultValue={fromDate}
            onChange={handleFromDateChange}
          />

          <TextField
            name="toDate"
            label="To"
            size="small"
            type="date"
            format={"DD/MM/YYYY"}
            variant="standard"
            InputLabelProps={{ shrink: true }}
            className={classes.filterWidth}
            defaultValue={toDate}
            onChange={handleToDateChange}
          />

          <div className={classes.buttons}>
            <Button
              variant="contained"
              size="small"
              type="submit"
              color="primary"
            >
              Search
            </Button>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={() => resetForm()}
            >
              Reset
            </Button>
          </div>
        </Grid>
      </form>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title=""
            options={{
              textLabels: {
                body: {
                  noMatch: "Oops! Matching record could not be found",
                },
              },
              pagination: false,
              sort: false,
              selectableRows: "none",
              search: false,
              filter: false,
              download: false,
              print: false,
              customToolbar: () => <HeaderElements />,
              responsive: mobileQuery === true ? "vertical" : "standard",
            }}
            columns={[
              {
                name: "S.No",
              },
              {
                name: "Actions",
              },
              {
                name: "Name",
              },
              {
                name: "Email",
              },
              {
                name: "Mobile",
              },
              {
                name: "Role",
              },
              {
                name: "Department",
              },
              {
                name: "Designation",
              },
              {
                name: "Status",
              },
              {
                name: "Posted Date",
              },
            ]}
            data={userData.map((user, index) => {
              return [
                <>
                  {currerntPage !== 0
                    ? 10 * currerntPage - 10 + index + 1
                    : index + 1}
                </>,
                <Tooltip title="View User" placement="right" aria-label="view">
                  <ViewIcon
                    onClick={() =>
                      history.push(`/app/emp-info?userId=${user.id}`)
                    }
                    className={classes.toolIcon}
                  />
                </Tooltip>,
                <>
                  {user.employee
                    ? user.employee.firstName
                    : user.recruiter
                    ? user.recruiter.firstName
                    : "N/A"}{" "}
                  {user.employee
                    ? user.employee.lastName
                    : user.recruiter
                    ? user.recruiter.lastName
                    : "N/A"}
                </>,
                user.email,
                user.employee
                  ? user.employee.mobile
                  : user.recruiter
                  ? user.recruiter.mobile
                  : "N/A",
                <>
                  {user?.roleName === "RECRUITER"
                    ? "Recruiter"
                    : user?.roleName === "CLIENTCOORDINATOR"
                    ? "Hiring Manager"
                    : user?.roleName === "SUBCONTRACT"
                    ? "Vendor"
                    : user?.roleName === "SUBVENDOR"
                    ? companyType === "COMPANY"
                      ? "Freelancer"
                      : "Sub Vendor"
                    : user?.roleName === "FREELANCER"
                    ? "Freelancer"
                    : user?.roleName === "EMPLOYEE"
                    ? "Employee"
                    : ""}
                </>,
                <>
                  {user.designation ? (
                    user.designation?.title
                  ) : (
                    <span className="emp-details-unvailable">Unavailable</span>
                  )}
                </>,
                <>
                  {user?.designation ? (
                    user.designation.department?.title
                  ) : (
                    <span className="emp-details-unvailable">Unavailable</span>
                  )}
                </>,
                <Switch
                  checked={user.isActive}
                  onChange={(e) => {
                    handleStatus(user.id, e.target.checked);
                  }}
                  color="primary"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />,

                moment(user.createdAt).format("DD-MM-YYYY"),
              ];
            })}
          />
        </Grid>
        <Grid item xs={12}>

          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
      </Grid>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
